// src/hooks/useDesignQuerySync.ts
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../app/hooks";

export const useDesignQuerySync = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const floorAndJob = useAppSelector((state) => state.design.floorAndJob);
  const rotation = useAppSelector((state) => state.design.rotation);
  const module = useAppSelector((state) => state.design.activeModule);

  const floorName = floorAndJob?.floorName ?? null;

  // Sync floor -> ?floor=
  useEffect(() => {
    if (!floorName) return;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const current = next.get("floor");
        if (current === floorName) {
          return prev;
        }
        next.set("floor", floorName);
        return next;
      },
      { replace: true }
    );
  }, [floorName, setSearchParams]);

  // Sync rotation -> ?rot=
  useEffect(() => {
    if (rotation == null) return;

    const rotString = String(rotation);

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const current = next.get("rot");
        if (current === rotString) {
          return prev;
        }
        next.set("rot", rotString);
        return next;
      },
      { replace: true }
    );
  }, [rotation, setSearchParams]);

  useEffect(() => {
    if (module == null) return;

    const moduleString = String(module);

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const current = next.get("module");
        if (current === moduleString) {
          return prev;
        }
        next.set("module", moduleString);
        return next;
      },
      { replace: true }
    );
  }, [module, setSearchParams]);
};
